import { getUserCount } from 'api/end-user/end-user.query'
import { getUserDetail } from 'api/user/user.query'
import { redirect } from 'react-router-dom'
import allRoutes from 'shared/lib/allRoutes'
import { isUserLoggedIn, userLogOut } from 'shared/lib/user'

export const privateLoader = (queryClient) => async () => {
  const token = isUserLoggedIn()

  if (token) {
    try {
      const [user, count] = await Promise.allSettled([
        queryClient.fetchQuery({ queryKey: ['getUserDetail'], queryFn: getUserDetail }),
        queryClient.fetchQuery({ queryKey: ['getUserCount'], queryFn: getUserCount })
      ])

      if (user?.reason?.status === 401) {
        userLogOut()
        return redirect(`/?from=${location.pathname}${location.search || ''}`)
      }
      return {
        token: token || null,
        user: user?.value?.data,
        userCount: count?.value?.data,
        permissions: user?.value?.data?.aPermissions || []
      }
    } catch (error) {
      if (error.status === 401) {
        userLogOut()
        return redirect(`/?from=${location.pathname}${location.search || ''}`)
      }
      return null
    }
  } else {
    // return null
    return redirect(`/?from=${location.pathname}${location.search || ''}`)
  }
}

export const publicLoader = async (e) => {
  if (isUserLoggedIn()) return redirect(allRoutes.dashboard)
  else return null
}
